import React from "react";
import productImage from "../../../assets/product.jpg";
import CheckIcon from "@mui/icons-material/Check";
import SC from "./style";
import theme from "../../../theme";

const fadeInLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 1 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const featcherItem = [
  {
    heading: "AI-Driven Operational Automation",
    description: "Eliminate repetitive coordination work.",
    content:
      "Prakalpa intelligently automates status updates, summaries, alerts, and reporting — freeing your teams to focus on delivery, not administration.",
  },
  {
    heading: "Unified Collaboration Intelligence",
    description: "Break down silos across teams, vendors and stakeholders.",
    content:
      "Prakalpa creates a single intelligence layer across tools and workflows, ensuring everyone operates with shared visibility and aligned priorities.",
  },
  {
    heading: "Real-Time Execution Visibility",
    description: "Know where you stand — at every moment.",
    content:
      "Monitor progress, dependencies, and bottlenecks with live dashboards powered by AI-driven signal detection.",
  },
  {
    heading: "Adaptive Workflows",
    description: "Every organization works differently.",
    content:
      "Prakalpa adapts to your structure, processes, and governance models — from agile digital programs to large-scale construction initiatives.",
  },
  {
    heading: "Predictive & Executive Reporting",
    description: "Stop reacting to delays.",
    content:
      "Prakalpa forecasts risks, analyzes delivery trends, and generates executive-ready insights — helping leadership act before problems escalate.",
  },
  {
    heading: "Secure, Cloud-Native Architecture",
    description: "Access intelligence anywhere, anytime.",
    content:
      "Built for enterprise-scale deployment with secure integrations and role-based access control.",
  },
];

function Product() {
  return (
    <div
      style={{
        background: theme.colors.background.main,
        padding: "5vw 5vw",
        borderTop: `0.2px solid`,
        borderBottom: `0.2px solid`,
        borderImage: `linear-gradient(90deg, transparent, ${theme.colors.text.quinary} 50%, transparent) 0.6`,
      }}
    >
      <SC.Container
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <SC.ContentSection
          whileInView="visible"
          initial="hidden"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInLeft}
        >
          {/* <SC.ProductLabel
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          Product
        </SC.ProductLabel> */}
          <SC.Title
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            From Task Management to <span>Execution Intelligence</span>
          </SC.Title>
          <SC.Description
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            Prakalpa enables - Smarter execution, Faster decisions and Stronger
            outcomes.
          </SC.Description>
          <SC.FeatureList>
            {featcherItem.map((feature, index) => (
              <SC.FeatureItem
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1, duration: 0.1 }}
                whileHover={{ scale: 1.1 }}
              >
                <CheckIcon />
                <div className="text-wrapper">
                  <span className="heading">
                    {feature.heading}{" "}
                    <span className="description">– {feature.description}</span>
                  </span>

                  <span className="content"> {feature.content}</span>
                </div>
              </SC.FeatureItem>
            ))}
          </SC.FeatureList>
        </SC.ContentSection>
        <SC.ImageContainer
          whileInView="visible"
          initial="hidden"
          viewport={{ once: true, amount: 0.4 }}
          variants={fadeIn}
        >
          <SC.Image
            src={productImage}
            alt="AI-powered project management tool Prakalpa"
          />
        </SC.ImageContainer>
      </SC.Container>
    </div>
  );
}

export default Product;
